import moment from "moment";
import { useEffect, useLayoutEffect, useState } from "react";
import { decodeToken, isExpired } from "react-jwt";

const useAuthz = () => {
  const [user] = useState((localStorage.getItem("user") !== null && localStorage.getItem("user") !== "undefined") ? JSON.parse(localStorage.getItem("user")) : null);
  const [token] = useState((localStorage.getItem("token") !== null && localStorage.getItem("token") !== "undefined") ? JSON.parse(localStorage.getItem("token")) : null);
  const [profil] = useState((localStorage.getItem("profil") !== null && localStorage.getItem("profil") !== "undefined") ? JSON.parse(localStorage.getItem("profil")) : null);

  const controlWindowLocalStore = () => {
    let localStoreIsValid = false;

    if (token !== null) {
      const decodedToken = decodeToken(token);

      if (!isExpired(token) && decodedToken && (!user.date_fin || moment(user.date_fin).isAfter(moment()))) {
        window.localStorage.setItem("profil", JSON.stringify({
          userId: decodedToken.userId,
          expirated_date: decodedToken.exp,
          profil: decodedToken.profil,
        }));
        localStoreIsValid = true;
      }
    }

    return localStoreIsValid;
  };

  const [authIsValid, setAuthIsValid] = useState(controlWindowLocalStore());

  const updateAuthz = () => {
    setAuthIsValid(controlWindowLocalStore());
  }

  useEffect(() => {
  }, [authIsValid])

  useLayoutEffect(() => {
    window.addEventListener('authz', updateAuthz);
    updateAuthz();
    return () => window.removeEventListener('authz', updateAuthz);
  }, []);

  return [authIsValid, user, profil];
};

export default useAuthz;